import Store from 'store/store';
import { joinPaths, sortObjectByOrder } from 'utils/utils';
import { getCopy } from 'utils/thundr';

const defaultPathsPerPage = { showtimes: '/tickets/', homeEnt: '/home-ent/', home: '/home/' };
function pagePath(page, item, status) {
	const isDefault = item?.pages?.[page]?.settings?.default ?? page === 'home';
	if (isDefault) return '/';
	return status?.[`${page}Path`] || defaultPathsPerPage[page] || '/';
}
function getMovieLink(item, status, page = '') {
	// Should we use an absolute URL for /movies/?
	const base = item.url || (item?.slug ? `/movies/${item.slug}/` : null);
	if (!base) return null;
	return joinPaths(base, pagePath(page, item, status));
}

function override(base, overrides, type) {
	let label = overrides?.[`${type}ButtonText`];
	if (label && !base) base = { type };
	if (label) base.label = label;

	if (!base) return null;

	let destination = overrides?.[`${type}ButtonLink`];
	if (destination) base.destination = destination;

	return base;
}

// Logic based on https://app.asana.com/1/8582257821148/task/1209230932412062?focus=true
export function getButtons(movie, overrides, thundrData) {
	if (!movie) return [];

	let defaultPrimaryButton;
	let defaultSecondaryButton;

	const learnMore = getCopy(thundrData, '$BUTTON_LEARN_MORE', 'Learn more');
	const trailer = sortObjectByOrder(movie?.trailers).find(trailer => trailer?.url);

	if (trailer) {
		defaultSecondaryButton = { label: getCopy(thundrData, '$BUTTON_TRAILER', 'Watch trailer'), destination: trailer.url, type: 'secondary' };
	}

	const status = movie.status || Store.get().movieStatuses?.[movie?.id];
	if (status?.theaters === 'comingSoon') {
		defaultPrimaryButton = { label: learnMore, destination: getMovieLink(movie, status), type: 'primary' };
	} else if (status?.theaters === 'preSale' || status?.theaters === 'inTheaters') {
		defaultPrimaryButton = { label: getCopy(thundrData, '$BUTTON_SHOWTIMES', 'Get tickets'), destination: getMovieLink(movie, status, 'showtimes'), type: 'primary' };
	} else if (status?.homeEnt === 'homeEnt') {
		defaultPrimaryButton = { label: getCopy(thundrData, '$BUTTON_HOMEENT', 'Watch at Home'), destination: getMovieLink(movie, status, 'homeEnt'), type: 'primary' };
	}

	if (status?.theaters === 'inTheaters' && status?.homeEnt === 'homeEnt') {
		defaultSecondaryButton = { label: getCopy(thundrData, '$BUTTON_HOMEENT', 'Watch at Home'), destination: getMovieLink(movie, status, 'homeEnt'), type: 'secondary' };
	}

	if (!defaultSecondaryButton && defaultPrimaryButton?.label !== learnMore) {
		defaultSecondaryButton = { label: learnMore, destination: getMovieLink(movie, status), type: 'secondary' };
	}

	return [
		override(defaultPrimaryButton, overrides, 'primary'),
		override(defaultSecondaryButton, overrides, 'secondary'),
	].filter(Boolean);
}